/**
 * ty-waitlist-phone.js
 *
 * מבריח את הטלפון של הנרשם לתוך שדה ששופיפיי כן שומרת.
 *
 * 🔴 הרקע, ונמדד ולא הונח: `{% form 'customer' %}` שולח `contact[phone]`,
 *    ושופיפיי **זורקת אותו בשקט**. אין שגיאה, הטופס מדווח הצלחה, והלקוח
 *    נוצר בלי טלפון. נמדד 08.09.2026 על הרשמה אמיתית: `phone` הוא null,
 *    null בכתובות, ו-null ב-note. התיעוד מונה `contact[email]` בלבד.
 *
 * ✅ **הוכרע במדידה 09.09.2026, על הרשמה אמיתית: `contact[note]` כן נשמר.**
 *    ⟹ הטלפון נשלח בהערה של הלקוח, «טלפון: 05XXXXXXXX», ותו לא.
 *
 * 🔴 **ותגית הטלפון ירדה, בהכרעת יובל.** היא עבדה, ונמדדה, **והיא מזהמת.**
 *    שופיפיי מחזיקה רשימה אחת של כל תגיות הלקוח בחנות, ולכן כל טלפון היה
 *    נכנס אליה כערך נפרד. ‏1,000 נרשמים = 1,000 מספרי טלפון בכל תיבת בחירת
 *    תגיות באדמין. ההערה מחזיקה את אותו מידע בדיוק ואינה נכנסת לשום רשימה.
 *    ⚠️ הניקוי של תגית `phone-` **נשאר**, כדי שרשומה ישנה לא תישא מספר
 *    שגוי אחרי הרשמה חוזרת.
 *
 * ⚠️ מה זה **לא** נותן, ואין לטעות בזה:
 *    ① הטלפון אינו בשדה הטלפון של הלקוח, ולכן אי אפשר לשלוח ממנו מסרון
 *      דרך שופיפיי.
 *    ② אין רשומת `smsMarketingConsent`. מי שרוצה לשלוח מסרונים חייב
 *      Shopify Forms. זה מתועד ב-docs/waitlist-2026-09-08/README.md.
 */
(function () {
  'use strict';

  var TAG_PREFIX = 'phone-';

  // 🔴 תגית הסכמה מפורשת. שופיפיי רושמת `emailMarketingConsent` עם חותמת
  //    זמן, וזו רשומה חזקה, אבל היא **מסומנת כמייל בלבד**. נוסח ההסכמה
  //    שלנו מכסה דוא"ל **וגם** מסרונים, ולכן צריך תיעוד שאומר את זה במפורש.
  //    ⚠️ שופיפיי אינה יכולה לשלוח מסרון על סמך תגית. זה תיעוד, לא ערוץ.
  var CONSENT_TAG = 'consent-email-sms';

  function digitsOnly(v) {
    return String(v || '').replace(/\D+/g, '');
  }

  /** מנרמל נייד ישראלי ל-05XXXXXXXX, ומחזיר '' אם אינו תקין.
   *  אותו כלל בדיוק כמו `isValidIsraeliMobile` ב-il-form-validation.js,
   *  כדי ששני המקומות לא ייפרדו. */
  function normalizeMobile(v) {
    var d = digitsOnly(v);
    if (d.indexOf('972') === 0) d = '0' + d.slice(3);
    return /^05\d{8}$/.test(d) ? d : '';
  }

  function stamp(form) {
    var tel = form.querySelector('input[type="tel"]');
    if (!tel) return;

    var phone = normalizeMobile(tel.value);

    // 🔴 הניקוי רץ **תמיד**, גם כשהטלפון פסול, ורק ההוספה מותנית.
    //    נתפס במדידה: כשהניקוי ישב אחרי יציאה מוקדמת, מספר תקין שהוחלף
    //    למספר פסול השאיר את **התגית הישנה** על הטופס. כלומר טלפון אחד
    //    בשדה ואחר בתגית, בלי שום סימן.
    var tagsInput = form.querySelector('.tyw__tags');
    if (tagsInput) {
      var parts = String(tagsInput.value || '')
        .split(',')
        .map(function (t) { return t.trim(); })
        .filter(function (t) { return t && t.indexOf(TAG_PREFIX) !== 0 && t !== CONSENT_TAG; });

      var box = form.querySelector('input[name="contact[marketing_consent]"]');
      if (box && box.checked) parts.push(CONSENT_TAG);

      tagsInput.value = parts.join(', ');
    }

    var noteInput = form.querySelector('.tyw__note');
    if (noteInput) noteInput.value = phone ? 'טלפון: ' + phone : '';
  }

  // 🔴 שלב הלכידה, ועל document. ‏il-form-validation.js רושם מאזין submit
  //    על הטופס עצמו בשלב הבעבוע, ולכן מאזין ברמת הטופס עלול לרוץ אחריו.
  //    כאן אנחנו תמיד ראשונים, והערך נשתל לפני שהבקשה יוצאת.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.classList && form.classList.contains('tyw__form')) stamp(form);
    },
    true
  );
})();
